import { useQuery } from "@tanstack/react-query";

import { getClient } from "services";
import { FEATURE_FLAGS_KEY } from "services/featureFlagsService";

import { getAppVersion } from "features/common/utils/functions/app";

export default function useFetchFeatureFlags({
  enabled
}: {
  enabled: boolean;
}) {
  const appVersion = getAppVersion();
  return useQuery({
    queryKey: [FEATURE_FLAGS_KEY],
    queryFn: async () =>
      getClient("featureFlagsService").fetchFeatureFlags(appVersion),
    enabled,
    refetchOnWindowFocus: false,
    retry: false,
    refetchOnMount: false,
    refetchInterval: false
  });
}
